<template>
	<svg :alt="alt" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M21.578 2.418L23.683 8.87L23.852 9.387H31.199L25.698 13.367L25.255 13.688L25.425 14.208L27.527 20.654L22.017 16.667L21.578 16.349L21.138 16.667L15.629 20.654L17.732 14.208L17.902 13.688L17.458 13.368L11.958 9.388H19.304L19.474 8.87L21.578 2.418ZM17.315 36C17.315 40.001 14.057 43.25 10.032 43.25C6.008 43.25 2.75 40.001 2.75 36C2.75 31.999 6.008 28.75 10.033 28.75C14.057 28.75 17.315 31.999 17.315 36ZM40.404 36.25H24.462L40.404 19.848V36.25Z" fill="white" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String,
	}
};
</script>
